import { VOID3gxj6tk5isa35 as VOID } from './void.mjs';
import { createMetadata3unb2gw4d2v4k as createMetadata } from './metadataUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { throwUnsupportedOperationException2oe5w0ywo7zbr as throwUnsupportedOperationException } from '../internal/ThrowHelpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_propertyRefClassMetadataCache() {
  _init_properties_reflectRuntime_kt__5r4uu3();
  return propertyRefClassMetadataCache;
}
var propertyRefClassMetadataCache;
function metadataObject() {
  _init_properties_reflectRuntime_kt__5r4uu3();
  return createMetadata('class', VOID, VOID, VOID, VOID, VOID);
}
function getPropertyCallableRef(name, paramCount, superType, getter, setter, linkageError) {
  _init_properties_reflectRuntime_kt__5r4uu3();
  getter.get = getter;
  getter.set = setter;
  getter.callableName = name;
  // Inline function 'kotlin.js.unsafeCast' call
  return getPropertyRefClass(getter, getKPropMetadata(paramCount, setter), superType);
}
function getPropertyRefClass(obj, metadata, superType) {
  _init_properties_reflectRuntime_kt__5r4uu3();
  obj.$metadata$ = metadata;
  obj.constructor = obj;
  var symbol = superType.Symbol;
  if (symbol != null) {
    // Inline function 'kotlin.js.asDynamic' call
    obj[symbol] = true;
  }
  Object.assign(obj, superType.prototype);
  return obj;
}
function getKPropMetadata(paramCount, setter) {
  _init_properties_reflectRuntime_kt__5r4uu3();
  return get_propertyRefClassMetadataCache()[paramCount][setter == null ? 0 : 1];
}
function getLocalDelegateReference(name, superType, mutable) {
  _init_properties_reflectRuntime_kt__5r4uu3();
  var lambda = () => {
    throwUnsupportedOperationException('Not supported for local property reference.');
  };
  return getPropertyCallableRef(name, 0, superType, lambda, mutable ? lambda : null, VOID);
}
var properties_initialized_reflectRuntime_kt_inkhwd;
function _init_properties_reflectRuntime_kt__5r4uu3() {
  if (!properties_initialized_reflectRuntime_kt_inkhwd) {
    properties_initialized_reflectRuntime_kt_inkhwd = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [metadataObject(), metadataObject()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [metadataObject(), metadataObject()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    propertyRefClassMetadataCache = [tmp, tmp_0, [metadataObject(), metadataObject()]];
  }
}
//region block: exports
export {
  getLocalDelegateReference as getLocalDelegateReference2ls94nvl5ojb2,
  getPropertyCallableRef as getPropertyCallableRef3hckxc0xueiaj,
};
//endregion

//# sourceMappingURL=reflectRuntime.mjs.map
